import { styled } from '../../../../stitches.config';

export const EditorSpacer = styled('div', {
  marginLeft: '4rem',
  marginRight: '7rem',
});
